import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import LoadingSpinner, { LoadingSpinnerProps } from "@insite/mobius/LoadingSpinner";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import parse from "html-react-parser";
import * as React from "react";
import { css } from "styled-components";

type Props = WidgetProps & HasProduct;

export interface ProductDetailsDescriptionStyles {
    centeringWrapper?: InjectableCss;
    spinner?: LoadingSpinnerProps;
    wrapper?: InjectableCss;
}

export const descriptionStyles: ProductDetailsDescriptionStyles = {
    centeringWrapper: {
        css: css`
            width: 100%;
            height: 300px;
            display: flex;
            align-items: center;
        `,
    },
    spinner: {
        css: css`
            margin: auto;
        `,
    },
    wrapper: {
        css: css`
            margin: 30px 0;
            h6 {
                margin-bottom: 5px;
                color: ${getColor("primary")};
                font-size: 16px;
                font-weight: 600;
            }
        `,
    },
};

const styles = descriptionStyles;

const ProductDetailsDescription: React.FC<Props> = ({ product }) => {
    if (!product.content) {
        return (
            <StyledWrapper {...styles.centeringWrapper}>
                <LoadingSpinner {...styles.spinner} data-test-selector="productDescriptionSpinner" />
            </StyledWrapper>
        );
    }

    return (
        <StyledWrapper {...styles.wrapper}>
            {product.content.htmlContent && <h6>Product Description:</h6>}
            <div data-test-selector="productDetails_htmlContent">
                {parse(product.content.htmlContent, parserOptions)}
            </div>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: withProduct(ProductDetailsDescription),
    definition: {
        displayName: "Description",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
